import IncidentResponse from 'containers/Settings/Incidence'
import ImpersonationProtection from 'containers/Settings/MailboxProtection'
import EndUserAlerts from 'containers/Settings/Notifications/EndUser'

export const GROUP_SETTINGS_PAGES = {
  INCIDENT_RESPONSE: 1,
  IMPERSONATION_PROTECTION: 2,
  END_USER_ALERTS: 3,
}

export const GROUP_SETTINGS_WIZARD_STEPS = [
  {
    key: GROUP_SETTINGS_PAGES.INCIDENT_RESPONSE,
    name: 'Incident Response',
    Component: IncidentResponse,
  },
  {
    key: GROUP_SETTINGS_PAGES.IMPERSONATION_PROTECTION,
    name: 'Impersonation Protection',
    Component: ImpersonationProtection,
  },
  {
    key: GROUP_SETTINGS_PAGES.END_USER_ALERTS,
    name: 'End-user Alerts',
    Component: EndUserAlerts,
  },
]